export const IndriyaTncs = [
  "This voucher entitles the bearer to ₹1,000 off on a minimum purchase of ₹1,00,000 at Indriya.",
  "Valid till 8th September 2026 Only.",
  "Applicable on all Jewellery products. (This excludes select jewellery pieces)",
  "Applicable only at participating Indriya stores. Not valid for online purchases unless explicitly stated.",
  "Not applicable on Gold & Silver Coin, Scheme Purchase, Bi-Metal, Platinum.",
  "Only one voucher may be used per transaction. Multiple vouchers cannot be clubbed.",
  "This offer is over and above the store offer prevailing at the time of purchase.",
  "This discount cannot be clubbed with an existing employee discount offer.",
  "This voucher is applicable for redemption of Gold Gain Program.",
];

export const IciciIndriyaTncs = [
  "Valid only till 15th December 2026.",
  "Valid over and above the existing active store offer.",
  "Not valid on Gold Coins, Silver, KVI, Back Chains & bullion.",
  "One invoice and one-time use only.",
  "Non-transferable, non-refundable & holds no cash value.",
  "Cannot be clubbed with any other voucher, or employee/corporate discount. Can not be clubbed with GQP schemes.",
  "Not valid on MTO orders if the delivery of that order is after the voucher expiry.",
  "In case of return/cancellation, coupon will not be reissued.",
  "Duplicate/tampered coupons will be rejected & may lead to blacklisting.",
  "Indriya reserves the right to modify/withdraw the offer.",
];
